(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rokka-brand-directory"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rokka-brand-directory')) {
    customElements.define('rokka-brand-directory', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const cards = [...this.querySelectorAll('[data-brand]')];
        const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('en');
        const initial = name => { const letter = normalize(name).slice(0, 1).toUpperCase(); return /^[A-Z]$/.test(letter) ? letter : '#'; };
        const input = this.querySelector('input');
        const buttons = [...this.querySelectorAll('[data-letter]')];
        const results = this.querySelector('.rk-directory__results');
        let selected = 'all';
        const update = () => {
          const term = normalize(input.value.trim());
          let count = 0;
          cards.forEach(card => { const name = card.dataset.brand; const show = normalize(name).includes(term) && (selected === 'all' || initial(name) === selected); card.hidden = !show; if (show) count++; });
          results.textContent = results.dataset.template.replace('__COUNT__', String(count));
          this.querySelector('.rk-directory__empty').hidden = count !== 0;
        };
        buttons.forEach(button => {
          button.disabled = button.dataset.letter !== 'all' && !cards.some(card => initial(card.dataset.brand) === button.dataset.letter);
          button.addEventListener('click', () => { selected = button.dataset.letter; buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button))); update(); });
        });
        input.addEventListener('input', update);
        this.querySelector('.rk-directory__search').hidden = false;
        this.querySelector('.rk-directory__letters').hidden = false;
        results.hidden = false;
        this.querySelectorAll('img').forEach(img => {
          const showFallback = () => {
            img.hidden = true;
            const fallback = img.parentElement.querySelector('.rk-directory__image-fallback');
            if (fallback) fallback.hidden = false;
          };
          img.addEventListener('error', showFallback);
          if (img.complete && !img.naturalWidth) showFallback();
        });
        update();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rokka-campaign-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rokka-campaigns')) {
    customElements.define('rokka-campaigns', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const menu = document.querySelector('#under-menu');
        if (menu) {
          this.menuObserver = new ResizeObserver(() => {
            const height = Math.max(menu.getBoundingClientRect().height, (menu.querySelector('ul')?.scrollHeight || 0) + 2);
            if (height > 0) this.style.setProperty('--rk-menu-height', `${height}px`);
          });
          this.menuObserver.observe(menu);
        }
        this.slides = [...this.querySelectorAll('.rk-campaign')];
        this.dots = [...this.querySelectorAll('[data-slide]')];
        if (!this.slides.length) { this.hidden = true; return; }
        this.index = 0;
        this.classList.add('is-ready');
        this.querySelector('.rk-campaign-controls').hidden = this.slides.length < 2;
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.dataset.direction) this.show(this.index + Number(button.dataset.direction));
          if (button.dataset.slide) this.show(this.slides.findIndex(slide => slide.id === button.dataset.slide));
        });
        this.addEventListener('pointerdown', event => { if (event.pointerType !== 'mouse') this.startX = event.clientX; });
        this.addEventListener('pointerup', event => {
          if (this.startX == null) return;
          const distance = event.clientX - this.startX;
          this.startX = null;
          if (Math.abs(distance) > 60) this.show(this.index + (distance < 0 ? 1 : -1));
        });
        this.addEventListener('pointercancel', () => { this.startX = null; });
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.indexOf(event.target.closest('.rk-campaign'));
          if (index >= 0) this.show(index);
        });
        this.show(0, false);
      }
      disconnectedCallback() { this.menuObserver?.disconnect(); }
      show(index, announce = true) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
        if (announce) this.querySelector('[data-status]').textContent = this.slides[this.index].querySelector('h2').textContent;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rokka-diet-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rokka-diet-filter')) {
    customElements.define('rokka-diet-filter', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.addEventListener('keydown', event => { if (event.key === 'Escape') { this.querySelector('details').open = false; this.querySelector('summary').focus(); } });
        if (this.dataset.collectionUrl) {
          this.initCollection();
          this.hidden = false;
          return;
        }
        const root = this.closest('.rad-page');
        if (!root) return;
        const aliases = {organic: ['organic', 'organic coffee'], vegan: ['vegan'], fat_free: ['fat free', 'fat-free'], gluten_free: ['gluten free', 'gluten-free']};
        const cards = [...root.querySelectorAll('[data-diet-tags]')].map(card => ({card, tags: JSON.parse(card.dataset.dietTags).map(tag => tag.toLowerCase().trim())}));
        const inputs = [...this.querySelectorAll('input')];
        const matches = (item, key) => aliases[key].some(tag => item.tags.includes(tag));
        inputs.forEach(input => {
          const count = new Set(cards.filter(item => matches(item, input.value)).map(item => item.card.href)).size;
          input.closest('label').querySelector('[data-count]').textContent = count;
          input.disabled = count === 0;
          if (!count) input.closest('label').title = this.querySelector('[data-unavailable]').textContent;
        });
        const update = () => {
          const selected = inputs.filter(input => input.checked).map(input => input.value);
          cards.forEach(item => { item.card.hidden = !selected.every(key => matches(item, key)); });
          root.querySelectorAll('.rad-scene').forEach(scene => { scene.hidden = !scene.querySelector('.rad-product:not([hidden])'); });
          this.querySelector('[data-empty]').hidden = cards.some(item => !item.card.hidden);
        };
        this.addEventListener('change', update);
        this.querySelector('[data-clear]').addEventListener('click', () => { inputs.forEach(input => { input.checked = false; }); update(); });
        this.hidden = false;
      }
      initCollection() {
        // Shopify handles tag filtering before pagination, including sorting and native facets.
        const handles = {organic: 'organic', vegan: 'vegan', fat_free: 'fat-free', gluten_free: 'gluten-free'};
        const normalize = tag => tag.toLowerCase().trim().replace(/\s+/g, '-');
        const tags = JSON.parse(this.dataset.tags || '[]').map(normalize);
        const active = (JSON.parse(this.dataset.currentTags || 'null') || []).map(normalize);
        const inputs = [...this.querySelectorAll('input')];
        inputs.forEach(input => {
          input.checked = active.includes(handles[input.value]);
          input.disabled = !input.checked && !tags.includes(handles[input.value]);
          if (input.disabled) input.closest('label').title = this.querySelector('[data-unavailable]').textContent;
        });
        const navigate = () => {
          const selected = inputs.filter(input => input.checked).map(input => handles[input.value]);
          const otherTags = active.filter(tag => !Object.values(handles).includes(tag));
          const path = [...otherTags, ...selected].map(encodeURIComponent).join('+');
          const url = new URL(this.dataset.collectionUrl + (path ? '/' + path : ''), location.origin);
          url.search = location.search;
          url.searchParams.delete('page');
          location.assign(url.href);
        };
        this.addEventListener('change', navigate);
        this.querySelector('[data-clear]').addEventListener('click', () => {
          inputs.forEach(input => { input.checked = false; });
          navigate();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rokka-quantity-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rokka-quantity-options')) {
    customElements.define('rokka-quantity-options', class extends HTMLElement {
      connectedCallback() {
        this.section = document.getElementById(`MainProduct-${this.dataset.section}`);
        this.form = document.getElementById(this.dataset.form);
        this.input = this.section?.querySelector('[name="quantity"]');
        if (!this.input || !this.form) return;
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.abort = new AbortController();
        this.section.addEventListener('change', () => this.sync(), {signal:this.abort.signal});
        this.sync();
      }
      disconnectedCallback() { this.abort?.abort(); }
      sync() {
        const picker = this.section.querySelector('variant-selects, variant-radios');
        const variant = picker && !picker.currentVariant && picker.options ? null : this.variants.find(item => String(item.id) === this.form.querySelector('[name="id"]').value);
        const stock = this.querySelector('.rokka-quantity-stock');
        const available = Boolean(variant?.available);
        stock.dataset.state = available ? 'available' : 'sold-out';
        const message = !available ? 'sold-out' : variant.tracked && variant.inventory > 0 ? 'in-stock' : 'available';
        stock.textContent = this.querySelector(`[data-${message}]`).textContent;
        if (variant) {
          this.input.min = variant.min || 1;
          this.input.step = variant.step || 1;
          let max = variant.max;
          if (variant.tracked && variant.policy === 'deny') max = max == null ? variant.inventory : Math.min(max, variant.inventory);
          if (max != null) this.input.max = max; else this.input.removeAttribute('max');
          if (available) {
            let value = Math.max(Number(this.input.value) || variant.min, variant.min);
            if (max != null) value = Math.min(value, max);
            this.input.value = variant.min + Math.floor((value - variant.min) / variant.step) * variant.step;
          }
        }

      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
